import React, { ImgHTMLAttributes } from "react";
import StaticHeader from "../../layout/header/StaticHeader";
import { TITLE_POSTFIX, TITLE_SEP } from "../DocumentTitle";
import { LoadErrorPage } from "./LoadErrorPage";
import Illustration from "./graphics/404_294x268.svg";
import styled from "styled-components";
import { onDesktop } from "@teamscheme/theme";

export const NotFoundIllustration = styled(function ({
  width = 268,
  ...props
}: Omit<
  ImgHTMLAttributes<HTMLImageElement>,
  "width" | "height" | "alt" | "src"
> & { width?: number }) {
  return (
    <img
      {...props}
      src={Illustration}
      alt="404"
      width={width}
      height={(268 / 294) * width}
    />
  );
})``;

export const NotFoundWrapper = styled.div`
  display: flex;
  flex-direction: column;

  ${onDesktop`
    flex-direction: row;
    justify-content: flex-start;
  `}
`;

export function NotFoundContent() {
  return (
    <div>
      <p>Siden du leter etter finnes ikke.</p>
      <p>
        Det kan være at siden rett og slett er utdatert eller at den har blitt
        flyttet. Hvis du har fulgt en lenke fra SMS, sjekk at du brukte den
        siste du mottok.
      </p>
    </div>
  );
}

export default function NotFoundScreen() {
  return (
    <>
      <StaticHeader />
      <LoadErrorPage
        title={`404 ${TITLE_SEP} Finner ikke siden ${TITLE_POSTFIX}`}
      >
        <NotFoundWrapper>
          <NotFoundContent />
          <NotFoundIllustration />
        </NotFoundWrapper>
      </LoadErrorPage>
    </>
  );
}
